import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { FrequencyPicker } from "@/components/FrequencyPicker";
import { MemberMultiSelect } from "@/components/shared";

export function ChoreDialog({ open, onOpenChange, editing, form, setForm, members, saving, onSave, onDelete }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto rounded-3xl">
        <DialogHeader>
          <DialogTitle className="font-display">{editing ? "Edit chore" : "New chore"}</DialogTitle>
          <DialogDescription className="sr-only">Chore details and schedule</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label>Title</Label>
            <Input
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              placeholder="Take out the trash"
              className="rounded-xl"
              data-testid="chore-title-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label>Points</Label>
            <Input
              type="number"
              min={0}
              value={form.points}
              onChange={(e) => setForm({ ...form, points: e.target.value })}
              className="rounded-xl"
              data-testid="chore-points-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label>Assign to</Label>
            <MemberMultiSelect
              members={members}
              value={form.member_ids}
              onChange={(ids) => setForm({ ...form, member_ids: ids })}
            />
          </div>
          <div className="space-y-1.5">
            <Label>Repeats</Label>
            <FrequencyPicker value={form} onChange={(v) => setForm({ ...form, ...v })} testIdPrefix="chore-freq" />
          </div>
        </div>
        <DialogFooter className="flex-row justify-between gap-2 sm:justify-between">
          {editing ? (
            <Button variant="ghost" className="rounded-xl text-destructive" onClick={onDelete} data-testid="chore-delete-btn">
              <Trash2 className="mr-1.5 h-4 w-4" /> Delete
            </Button>
          ) : (
            <span />
          )}
          <Button className="rounded-xl" onClick={onSave} disabled={saving} data-testid="chore-save-btn">
            {saving ? "Saving…" : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
